
// Defines the key value
export const main_key = "_meta.moduleItemLinkId";